import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets.app/images/no-search.svg'


const _hoisted_1 = { class: "book-simple-box" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "search-empty" }
const _hoisted_4 = { class: "search-empty__title" }


export default /*@__PURE__*/_defineComponent({
  __name: 'NoSearchResults',
  props: {
    term: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          class: "search-empty__img",
          src: _imports_0
        }, null, -1)),
        _createElementVNode("h3", _hoisted_4, "No results found for \"" + _toDisplayString(__props.term) + "\"", 1),
        _cache[2] || (_cache[2] = _createElementVNode("p", null, " Try another search, or send us an email with books and podcasts suggestions that you're interested in! ", -1)),
        _createVNode(_component_router_link, {
          to: { name: 'help' },
          class: "btns btns--font-medium btns--white search-empty__btn"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Request books or podcasts from us", -1)
          ]))]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})